import { Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { LayoutPage } from "./pages/LayoutPage";
import { FormPage } from "./pages/FormPage";
import { FooterPage } from "./pages/FooterPage";
import { TelegramPage } from "./pages/TelegramPage";
import { AvisLegalPage } from "./pages/AvisLegalPage";
import { PoliticaPrivacitatPage } from "./pages/PoliticaPrivacitatPage";

function App() {
  return (
    <>
      {/* <LayoutPage /> */}
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="/busco-pis" element={<FormPage />} />
        <Route path="/telegram" element={<TelegramPage />} />
        <Route path="/avis-legal" element={<AvisLegalPage />} />
        <Route path="/privacitat" element={<PoliticaPrivacitatPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      <FooterPage />
    </>
  );
}

export default App;
